import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./previousWork.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { useUserAuth } from "../../../context/UserAuthContext";
import axios from "axios";

const AllPreviousWork = () => {
  const { user, token } = useUserAuth();
  const merchant_id = user.uid;
  const [loading, setLoading] = useState(true);
  const [imgList, setImgList] = useState([]);
  const [imgUrl, setImgUrl] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [curId, setCurId] = useState(null);
  const [updating, setUpdating] = useState(false);
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const getSingleDocumentHandler = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${base_url}/api/v1/previous-work/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setImgList(res.data.data);
    } catch (error) {
      console.error(`Error fetching images: ${error}`);
      toast.error("Failed to load images");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id]);

  const deleteBtnHandler = async (id) => {
    const choice = window.confirm(
      "Are you sure you want to delete this image?",
    );
    if (choice) {
      try {
        await axios.delete(`${base_url}/api/v1/previous-work/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setImgList((prevList) => prevList.filter((pre) => pre.id !== id));
        toast.success("Image deleted successfully");
      } catch (err) {
        toast.error(err.message || "Failed to delete image");
        console.error(err);
      }
    }
  };

  const imgHandler = (imageUrl, id) => {
    setCurId(id);
    setImgUrl(imageUrl);
    setShow(true);
  };

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setNewImage(null);
  };

  const editBtnHandler = async () => {
    if (!newImage) {
      toast.error("Please select an image first!");
      return;
    }

    const formData = new FormData();
    formData.append("image", newImage);
    setUpdating(true);

    try {
      const res = await axios.put(
        `${base_url}/api/v1/previous-work/${curId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Update the specific image in the list while maintaining position
      setImgList((prevList) =>
        prevList.map((item) =>
          item.id === curId
            ? {
                ...item,
                mobile_image: res.data.updatedRecord.mobile_image,
                tablet_image: res.data.updatedRecord.tablet_image,
                desktop_image: res.data.updatedRecord.desktop_image,
              }
            : item,
        ),
      );

      toast.success("Image updated successfully");
      handleClose();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to update image");
    } finally {
      setUpdating(false);
    }
  };

  const makeProfilePictureHandler = async (id) => {
    const choice = window.confirm(
      "Are you sure you want to make this image primary?",
    );
    if (!choice) return;

    try {
      const response = await axios.put(
        `${base_url}/api/v1/vendors/previous-work/${id}/set-primary`,
        { user_id: merchant_id },
      );

      if (response.data.success) {
        setImgList((prevList) => {
          // make a deep copy to avoid mutation side-effects
          const listCopy = [...prevList];

          // find selected image index
          const index = listCopy.findIndex((img) => img.id === id);
          if (index === -1) return prevList; // not found safeguard

          // extract that image
          const [selectedImage] = listCopy.splice(index, 1);

          // mark it as primary (optional if backend doesn’t return it)
          selectedImage.is_primary = true;

          // mark others as non-primary
          const updatedRest = listCopy.map((img) => ({
            ...img,
            is_primary: false,
          }));

          // return reordered array
          return [selectedImage, ...updatedRest];
        });
        toast.success("Image set as primary successfully");
      } else {
        toast.error("Failed to set primary image:", response.data.message);
      }
    } catch (error) {
      toast.error("Error setting primary image:", error);
      console.error("Error setting primary image:", error);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3">
            <img
              src={imgUrl}
              style={{
                maxWidth: "100%",
                maxHeight: "300px",
                objectFit: "contain",
                border: "1px solid #ddd",
                borderRadius: "4px",
              }}
              alt="Current"
              className="mb-3"
            />
          </div>

          <div className="d-flex align-items-center gap-3">
            <div className="flex-grow-1">
              <input
                type="file"
                className="form-control"
                onChange={(e) => setNewImage(e.target.files[0])}
                accept="image/*"
                disabled={updating}
                id="image-upload"
              />
            </div>
            <button
              className="btn btn-primary"
              onClick={editBtnHandler}
              disabled={updating || !newImage}
            >
              {updating ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Main Content */}
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="text-white d-flex justify-content-between align-items-center px-3" style={{ backgroundColor: "#085f9a", height: "50px" }}>
                  <Link to="/dashboard/previous-work" className="text-white btn p-0">
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  <h5 className="mb-0 ms-auto text-end">
                    Gallery
                  </h5>
                </div>
                <div className="card-body">
                  {loading ? (
                    <div className="row">
                      {Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} className="col-md-3 col-sm-6 col-6 mb-4">
                          <Skeleton
                            style={{
                              height: "150px",
                              width: "100%",
                              borderRadius: "8px"
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : imgList.length === 0 ? (
                    <div className="text-center py-5">
                      <h4>No images found</h4>
                      <p>
                        Upload your previous work to showcase your portfolio
                      </p>
                    </div>
                  ) : (
                    <div className="row">
                      {imgList.map((item) => (
                        <div
                          className="col-md-3 col-sm-6 col-6 mb-4"
                          key={item.id}
                        >
                          <div className="img-box-container">
                            <div className="img-box position-relative">
                              <img
                                src={item.mobile_image}
                                alt="Previous Work"
                                className="img-fluid"
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  aspectRatio: "1/1",
                                  height: "150px",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                                onClick={() =>
                                  imgHandler(item.mobile_image, item.id)
                                }
                              />
                              <button
                                className="btn btn-danger btn-sm position-absolute"
                                style={{
                                  top: "5px",
                                  right: "5px",
                                  zIndex: 10,
                                  borderRadius: "50px",
                                  height: "30px",
                                  width: "30px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteBtnHandler(item.id);
                                }}
                              >
                                <DeleteIcon style={{ fontSize: "16px" }} />
                              </button>
                              <span
                                className="position-absolute"
                                style={{
                                  top: "5px",
                                  left: "5px",
                                  zIndex: 10,
                                  backgroundColor: item.status
                                    ? "#28a745"
                                    : "#e68d09ff",
                                  color: "white",
                                  padding: "4px 10px",
                                  borderRadius: "24px",
                                  fontSize: "10px",
                                }}
                              >
                                {item.status ? "Approved" : "Review"}
                              </span>
                              {!item.is_primary ? (
                                <button
                                  className="position-absolute"
                                  style={{
                                    bottom: "10px",
                                    left: "10px",
                                    zIndex: 10,
                                    color: "white",
                                    backgroundColor: "#1475cf",
                                    padding: "4px 8px",
                                    borderRadius: "24px",
                                    fontSize: "10px",
                                    border: "none",
                                  }}
                                  onClick={() =>
                                    makeProfilePictureHandler(item.id)
                                  }
                                >
                                  Make Profile Picture
                                </button>
                              ) : (
                                <span
                                  className="position-absolute"
                                  style={{
                                    bottom: "10px",
                                    left: "10px",
                                    zIndex: 10,
                                    color: "white",
                                    backgroundColor: "#28a745",
                                    padding: "4px 8px",
                                    borderRadius: "24px",
                                    fontSize: "10px",
                                    border: "none",
                                  }}
                                >
                                  Current Profile Picture
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllPreviousWork;
